var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('vimeo-player',{attrs:{"video-id":211493971}}),_vm._v(" "),_c('vimeo-player',{attrs:{"video-id":209773126}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }